import { useState, useEffect } from 'react';
import { nodeToStageMapping } from '../data/processFlowData';
import { ProcessStep } from '@/types/processFlowTypes';

export const useProcessStage = (
  externalStage?: string,
  externalStageClick?: (stage: string) => void
) => {
  const [currentStage, setCurrentStage] = useState<string>(externalStage || 'input');
  const [selectedStep, setSelectedStep] = useState<ProcessStep | null>(null);

  // Update internal state when props change
  useEffect(() => {
    if (externalStage && externalStage !== currentStage) {
      setCurrentStage(externalStage);
    }
  }, [externalStage, currentStage]);

  const handleStageClick = (node: ProcessStep) => { 
    setSelectedStep({
      id: node.id,
      label: node.label || '',
      description: node.description || '',
      instructions: node.instructions || ''
    });  
    
    if (nodeToStageMapping[node.id]) {
      const newStage = nodeToStageMapping[node.id];
      setCurrentStage(newStage);
      if (externalStageClick) {
        externalStageClick(newStage);
      }
    }
  };

  return {
    currentStage,
    selectedStep,
    handleStageClick
  };
};
